<template>
  <DxTagBox placeholder="Search..."
            v-model:value="searchObjectsModel"
            value-expr="this"
            display-expr="text"
            :accept-custom-value="true"
            :show-clear-button="true"
            :open-on-field-click="false"
            @custom-item-creating="createTextSearch"
  >
    <i class="dx-icon-find dx-icon-custom-style"></i>
  </DxTagBox>
</template>

<script setup>
  import { computed } from "vue";
  import { DxTagBox } from "devextreme-vue";

  const props = defineProps(['searchBarObjects'])

  const emit = defineEmits(['update:searchBarObjects'])

  const searchObjectsModel = computed({
    get: () => props.searchBarObjects,
    set: (value) => emit('update:searchBarObjects', value)
  })

  const createTextSearch = (inputEvent) => {
    if(inputEvent.text.trim())
      inputEvent.customItem = { type: 'text', text: inputEvent.text }
    else
      inputEvent.customItem = null
  }
</script>

<style scoped lang="scss">
</style>
